module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/notifications-17ab79444edb1f016f77afd88284691f.svg";